"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var MeatballMenu_1 = __importDefault(require("../common/MeatballMenu"));
var types_1 = require("@/Types/types");
var MediaPreviewModal_1 = __importDefault(require("./MediaPreviewModal"));
var MeatballMenuField = function (_a) {
    var onDownloadMedia = _a.onDownloadMedia, onDeleteFolder = _a.onDeleteFolder, onDeleteMedia = _a.onDeleteMedia, onDetails = _a.onDetails, openFolderAccessModal = _a.openFolderAccessModal, folderPermissions = _a.folderPermissions;
    var record = (0, react_admin_1.useRecordContext)();
    if (!record)
        return null;
    var _b = (0, react_1.useState)(false), previewModalShown = _b[0], setPreviewModalShown = _b[1];
    var _c = (0, react_1.useState)(null), previewImageUrl = _c[0], setPreviewImageUrl = _c[1];
    var _d = (0, react_1.useState)(null), previewMediaType = _d[0], setPreviewMediaType = _d[1];
    var togglePreviewModal = (0, react_1.useCallback)(function () {
        setPreviewModalShown(function (prev) { return !prev; });
    }, []);
    var handleViewMedia = (0, react_1.useCallback)(function (e, media) {
        e.stopPropagation();
        setPreviewImageUrl(media.url);
        setPreviewMediaType(media.mime_type);
        togglePreviewModal();
    }, [togglePreviewModal]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MeatballMenu_1.default, { resourceId: record.id, onView: function (e) {
                if (record.type === "MEDIA") {
                    handleViewMedia(e, record);
                }
            }, onDownload: function () {
                if (record.type === "MEDIA") {
                    onDownloadMedia(record.originalId);
                }
                else {
                    return;
                }
            }, onDetails: function (event) {
                if (record.type === "MEDIA") {
                    onDetails(record, event);
                }
                else {
                    return;
                }
            }, onDelete: function () {
                if (record.type === "FOLDER") {
                    onDeleteFolder(record.id);
                }
                else {
                    onDeleteMedia(record.originalId);
                }
            }, onManageResourceAccess: function () {
                if (record.type === "FOLDER") {
                    openFolderAccessModal(record.id);
                }
                else {
                    return;
                }
            }, folderPermissions: folderPermissions, menuSx: { marginLeft: "25px", marginBottom: "200px" }, resourceType: record.type === "FOLDER" ? types_1.ResourceType.FOLDER : types_1.ResourceType.MEDIA }),
        react_1.default.createElement(MediaPreviewModal_1.default, { isShown: previewModalShown, toggle: togglePreviewModal, url: previewImageUrl !== null && previewImageUrl !== void 0 ? previewImageUrl : "", mediaType: previewMediaType !== null && previewMediaType !== void 0 ? previewMediaType : "" })));
};
exports.default = MeatballMenuField;
